<template>
  <div v-if="isShow" class="c-search-block">
    <div class="c-search-block__overlay" @click.stop="$emit('hide')"></div>
    <div class="c-search-block__inner" :class="'c-search-block__inner--' + viewMode">
      <FormsKeywordSearch
        :placeholder="
          !$utils.isSmartPhone()
            ? '施設名、メニューNo、地名などを入力（例：東京　温泉）'
            : 'キーワード、店名、地名など'
        "
        @input="input"
        @onSearch="onSearch(form.keyword)"
        :background="$utils.isSmartPhone()"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    viewMode: {
      type: String,
      default: 'PC'
    }
  },
  data() {
    return {
      form: {
        keyword: ''
      }
    }
  },
  computed: {},
  methods: {
    input(args) {
      this.form.keyword = args
    },
    getQueryString(keyword = '') {
      if (this.form.keyword) {
        keyword = {
          keyword: this.form.keyword
        }
      }
      return {
        category: 'stay',
        rooms: 1,
        roomCnt: 1,
        numPeople: 2,
        stayNights: 1,
        adultHeadCnt: 2,
        ...keyword
      }
    },
    onSearch(keyword = '') {
      if (!keyword) return
      this.$emit('onSearch', keyword)
      this.$router.push({
        path: '/search/menu',
        query: this.getQueryString(keyword)
      })
      this.form.keyword = ''
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.c-search-block {
  position: relative;
  &__inner {
    padding: 1rem;
    &--PC {
      position: absolute;
      right: 0;
      z-index: 10001;
      min-width: 616px;
      background-color: #f4f5f6;
      border-radius: 8px;
      @screen sm {
        display: none;
      }
    }
    &--SP {
      display: none;

      @screen sm {
        position: relative;
        display: block;
        background-color: #fff;
        padding: 2.5rem 0;
        z-index: 10001;
        .c-input {
          position: absolute;
          width: calc(100% - 2rem);
          top: 50%;
          left: 50%;
          transform: translate(-49%, -50%);
        }
      }
    }
  }
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vw;
    background-color: transparent;
    z-index: 10000;
  }
}

.c-input {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0.75rem 1rem;
}

.c-input.c-input--group .c-input__text:first-child {
  height: 3rem;
  border-radius: 0.5rem 0 0 0.5rem;
}
</style>
